/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Company_Taxpayer_Id_LabelInputs */

const es_co2_signup_company_taxpayer_id_label = /** @type {(inputs: Signup_Company_Taxpayer_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NIT`)
};

/**

* @param {Signup_Company_Taxpayer_Id_LabelInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_company_taxpayer_id_label = /** @type {((inputs?: Signup_Company_Taxpayer_Id_LabelInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Company_Taxpayer_Id_LabelInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_company_taxpayer_id_label(inputs)
});